export default {
  ['setSearchQuery'](state, payload) {
    state.searchQuery = payload
  },
  ['setSearchResults'](state, payload) {
    state.searchResults = payload
  }
}
